import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "./EsameDetailPage.css";

const RinofaringolaringoscopiaPage: React.FC = () => {
  return (
    <div className="esame-detail-page">
      <div className="esame-detail-container">
        <Link to="/esami" className="esame-detail-back">
          <FontAwesomeIcon icon={faArrowLeft} />
          Torna agli esami
        </Link>

        <div className="esame-detail-content">
          <div className="esame-detail-text">
            <h1 className="esame-detail-title">
              Rinofaringolaringoscopia a Fibre Ottiche
            </h1>

            <div className="esame-detail-description">
              <h2>Cos'è</h2>
              <p>
                La rinofaringolaringoscopia a fibre ottiche è un esame
                endoscopico in cui si utilizza una sottile fibra ottica che
                esplora le cavità nasali, la faringe, la laringe e trasmette le
                immagini dettagliate e ad alta risoluzione su un monitor.
              </p>

              <h2>A cosa serve</h2>
              <p>
                Questo esame serve per individuare e studiare patologie come
                sinusiti, polipi nasali, adenoidi ingrossate, noduli ma anche
                tumori del distretto testa collo. Inoltre è indicata per la
                valutazione della voce, della deglutizione e per il russamento
                notturno.
              </p>

              <h2>Dove si svolge</h2>
              <p>
                L'esame si esegue in ambulatorio, è indolore, il disagio è minimo e si può fare a qualsiasi età.
              </p>
            </div>
          </div>

          <div className="esame-detail-image-container">
            <img
              src={require("../assets/carousel/PHOTO-2025-10-16-20-09-03 2.jpg")}
              alt="Rinofaringolaringoscopia"
              className="esame-detail-image"
            />
          </div>
        </div>

        <div className="esame-detail-cta">
          <h3>Vuoi prenotare questo esame?</h3>
          <p>
            Contattaci per maggiori informazioni o per fissare un appuntamento
          </p>
          <Link to="/#prenota" className="esame-detail-cta-btn">
            Prenota ora
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RinofaringolaringoscopiaPage;
